module.exports = __webpack_public_path__ + "static/theme-editor-brands-page-layout-136ff00d73431f54c3de024ae5ae4353.png";